var AddedLeaguesModifier = /** @class */ (function () {
    function AddedLeaguesModifier(modelKeyRepository) {
        this._modelKeyRepository = modelKeyRepository;
    }
    AddedLeaguesModifier.prototype.modify = function (content) {
        if (content.leagues === undefined || content.leagues.add === undefined) {
            return;
        }
        var leagues = content.leagues.add;
        for (var i = 0; i < leagues.length; i++) {
            var league = leagues[i];
            var key = this._modelKeyRepository.addLeague(league.s, league.id);
            leagues[i] = Object.assign({
                name: league.n.split('.').join(''),
                priority: league.p,
                eventCount: league.ec
            }, key);
        }
    };
    return AddedLeaguesModifier;
}());
export default AddedLeaguesModifier;



// WEBPACK FOOTER //
// ./src/repositories/modifier/AddedLeaguesModifier.js